import React from 'react';
import config from '../../configuration';

const PrimaryButton = ({ onClick, children, style, className, scale }) => {
  return (
    <>
      <div
        style={{
          cursor: 'pointer',
          background: config.colors.primary,
          boxSizing: 'border-box',
          borderRadius: 6 * scale,
          fontSize: 12 * scale,
          fontWeight: 700,
          paddingTop: 10 * scale,
          paddingBottom: 10 * scale,
          paddingLeft: 20 * scale,
          paddingRight: 20 * scale,
          lineHeight: 1.15 * scale,
          textAlign: 'center',
          ...style
        }}
        onClick={onClick}
        className={className ? 'primary-button ' + className : 'primary-button'}
      >
        {children}
      </div>
    </>
  );
};

export default PrimaryButton;
